import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "../pages/Home";
import { Store } from "../pages/Store";
import { Contact } from "../pages/Contact";
import { ProductDetail } from "../pages/ProductDetail";
import { ScrollToTop } from "../components/ScrollToTop/ScrollToTop";
import { Collection } from "../pages/Collection";
import { Catalog } from "../pages/Catalog";
import { Searching } from "../pages/Searching/Searching";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Check } from "../pages/Checkout";
import { Influencers } from "../pages/Influencers";
import { Ambassadors } from "../pages/Ambassadors";
import { ReturnPolicy } from "../pages/ReturnPolicy";
export const Navigation = () => {
  return (
    <BrowserRouter>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} index />
        <Route path="/store" element={<Store />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/influencers" element={<Influencers />} />
        <Route path="/ambassadors" element={<Ambassadors  />} />
        <Route path="/search" element={<Searching />} />
        <Route path="/products/:id" element={<ProductDetail />} />
        <Route path="/checkout" element={<Check/>} />
        <Route path="/collections/:name" element={<Collection />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};
